var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaCalendarOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.555 13.383C4.25989 14.8086 5.40339 15.9705 6.8175 16.698C8.22125 17.4192 9.82199 17.6626 11.3767 17.3913C12.9361 17.1169 14.3648 16.3451 15.4492 15.1913C16.5433 14.0264 17.24 12.5446 17.4392 10.9588C17.6411 9.36946 17.3366 7.75689 16.5692 6.35051C15.8087 4.95483 14.6201 3.84036 13.1783 3.17134C11.7464 2.50815 10.1372 2.33026 8.595 2.66468C7.05333 2.99884 5.79 3.75884 4.745 4.96051C4.61917 5.09384 4.1325 5.63218 3.72833 6.44468M6.25 6.66634L3.2425 7.26634L2.5 4.16634M10 7.49968V10.833L12.5 12.4997",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaCalendarOutline);
export default __webpack_public_path__ + "static/media/eva_calendar_outline.2f2ee0eb93c406d96ff6ee2587a2a590.svg";
export { ForwardRef as ReactComponent };